import '@babel/polyfill';
import Vue from 'vue';
import Vuex from 'vuex';
import '@fortawesome/fontawesome-free/css/all.css';
import './plugins/vuetify';
import 'es6-promise/auto';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from 'axios';
import interceptorsSetup from './helpers/interceptors';
import * as Sentry from '@sentry/browser';

Vue.config.productionTip = false;
Vue.use(Vuex);

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;
interceptorsSetup();

Sentry.init({
  dsn: 'https://7d8d9a0eec324f89aeff8b3b2a32f6b4@sentry.io/1312653',
  integrations: [new Sentry.Integrations.Vue({ Vue })],
  environment: process.env.VUE_APP_MODE
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
